module.exports = __webpack_public_path__ + "img/logo7.ebd88dec.png";